export const FILTER_SERVER_MAPPER_DASHBOARD = {
  unitId: 'unidad',
  targetUserId: 'usuarioPaso'
};
